import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
//import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
//import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
// import AppBar from "@mui/material/AppBar";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LinkIcon from "@mui/icons-material/Link";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function OptionDialog(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { open, handleClose, handleOk, options: _options } = props;
  //const [value, setValue] = React.useState(0); // tabs
  const [options, setOptions] = React.useState([]); // images

  const handleEntering = () => {
    setOptions(_options);
  };
  /*
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  const handleChangeIndex = (index) => {
    setValue(index);
  }; */

  function checkURL(url) {
    if (url === "") return true;
    if (typeof url !== "string") return false;
    return (
      //eslint-disable-next-line
      url.match(/^http[^\?]*.(jpg|jpeg|gif|png|tiff|bmp|svg)(\?(.*))?$/gim) !=
      null
    );
  }

  function getImage(option) {
    if (option.img === "")
      return `${window.REACT_APP_IMAGE_PATH}/placeholder-image.png`;

    if (checkURL(option.img)) {
      return option.img;
    }
  }

  const handleFocus = (event) => {
    event.preventDefault();
    const { target } = event;
    const lastChar = target.value.length;
    target.focus();
    target.setSelectionRange(0, lastChar);
  };

  const updateOptions = (option, url) => {
    const newOption = { ...option, img: url };
    setOptions((prev) =>
      prev.map((item) => (item.id === option.id ? newOption : item))
    );
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        onEntering: handleEntering,
      }}
      sx={{ maxWidth: "sm", margin: "auto" }}
    >
      <React.Fragment>
        {/* <div style={{ background: theme.palette.background.paper }}>
          <DialogTitle id="options-dialog-title" style={{paddingBottom: 0}}>Options</DialogTitle>
          <AppBar
            position="static"
            style={{
              background: theme.palette.background.toolbar,
              boxShadow: "0 5px 8px -3px grey",
            }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <StyledTab label="Specific" {...a11yProps(0)} />
              <StyledTab label="General" {...a11yProps(1)} />
              <StyledTab label="Curate" {...a11yProps(2)} />
            </StyledTabs>
          </AppBar> 
        </div>*/}
        <DialogContent>
          {/*           <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}> */}
          <Typography variant="h6">
            {t("editor.optionsDialog.title")}
          </Typography>
          <Box paddingBottom={2} display="flex" alignItems={"center"}>
            <Typography variant="subtitle2">
              {t("editor.optionsDialog.insertImages")}
            </Typography>
            <IconButton
              size="small"
              onClick={() =>
                window.open(
                  "https://m-path.io/manual/knowledge-base/images/",
                  "_blank"
                )
              }
            >
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box>
            <Grid container spacing={3}>
              {options.map((option) => (
                <Grid item xs={6} key={option.id}>
                  <Card>
                    <CardMedia
                      sx={{ width: "100px", height: "100px", margin: "auto" }}
                      image={getImage(option)}
                      title={option.title}
                    />
                    {/* <input
                          accept="image/*"
                          className={classes.input}
                          style={{display: "none"}}
                          id="contained-button-file"
                          multiple
                          type="file"
                        />
                        <label htmlFor="contained-button-file">
                          <Button
                            variant="contained"
                            color="primary"
                            component="span"
                          >
                            Upload
                          </Button>
                        </label> */}
                    <CardContent sx={{ width: "100%" }}>
                      <Typography variant="body2" color="textSecondary">
                        {option.title}
                      </Typography>
                      <TextField
                        error={!checkURL(option.img)}
                        helperText={
                          checkURL(option.img)
                            ? ""
                            : t("editor.optionsDialog.invalidImage")
                        }
                        onChange={(e) => updateOptions(option, e.target.value)}
                        defaultValue={option.img}
                        placeholder={t("editor.optionsDialog.pastePlaceholder")}
                        onFocus={handleFocus}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LinkIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: "100%" }}
                        variant="standard"
                      />
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
          {/*    </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              Item Three
            </TabPanel>
          </SwipeableViews> */}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="inherit">
            {t("common.actions.cancel")}
          </Button>
          <Button
            onClick={() => {
              // check if images are added
              let hasImages = false;
              options.forEach((option) => {
                if (checkURL(option.img) && option.img.length > 0) {
                  hasImages = true;
                }
              });
              handleOk({ options, hasImages });
            }}
            color="primary"
          >
            {t("common.actions.ok")}
          </Button>
        </DialogActions>
      </React.Fragment>
    </Dialog>
  );
}
